import EmailOverview from "./EmailOverview";

function MarketingPerformanceEmailPage() {
  return <EmailOverview />;
}

export default MarketingPerformanceEmailPage;
